module.exports = __webpack_public_path__ + "static/background-9ea831e725ea664af12a93432c6d0493.jpg";